import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/feature/ScrollToTop";
import JsonLd from "./components/feature/JsonLd";

const siteUrl = (import.meta.env.VITE_SITE_URL || "").replace(/\/+$/, "");

const webSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Basetao Sheet Guide",
  url: siteUrl ? `${siteUrl}/` : undefined,
  description:
    "An independent resource for Basetao Spreadsheet guides, finds, reviews, shipping and product research.",
};

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <JsonLd data={webSiteSchema} />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;